import { Children, cloneElement, useCallback, useContext, useEffect, useState } from "react";
import { getOauthIndentityProviderUrl } from "app/utils/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { STRATEGY } from "app/constants";
import AppGlobalsContext from "app/AppGlobalsContext";
import { parseQueries } from "app/utils/routerUtils";
import { sendTagOnOauthAccessTokenFailed } from "app/utils/analytics";
import { isAuthenticated as isAuthenticatedSelector } from "app/pages/Auth/authSelectors";
import { useSelector, useDispatch } from "react-redux";
import { getOAuthToken as getOAuthTokenAction } from "app/pages/Auth/OAuth/oAuthActionCreators";

// eslint-disable-next-line react/prop-types
const OauthRoute = ({ children }) => {
	const isAuthenticated = useSelector(state => isAuthenticatedSelector(state));
	const dispatch = useDispatch();
	const getOAuthToken = useCallback(arg => dispatch(getOAuthTokenAction(arg)), [dispatch]);
	const { strategy, envVars } = useContext(AppGlobalsContext);
	const { search = {} } = useLocation();
	const { code } = parseQueries(search);

	const navigate = useNavigate();

	const [showComponent, updateShowComponent] = useState(isAuthenticated);

	const environment = envVars.ENVIRONMENT;

	useEffect(() => {
		if (!isAuthenticated && strategy === STRATEGY.OAUTH && !code) {
			// redirectUri must not be encoded, otherwise the Cdiscount Oauth server will throw a
			// "innerexception":null,"message":"Invalid URI: The format of the URI could not be determined." error
			const redirectUri = window.location.origin + window.location.pathname;
			window.location.replace(getOauthIndentityProviderUrl(redirectUri, environment));
		}
	}, [isAuthenticated, code, strategy, environment]);

	useEffect(() => {
		if (code && strategy === STRATEGY.OAUTH) {
			// redirectUri must not be encoded, otherwise the Cdiscount Oauth server will throw a
			// "innerexception":null,"message":"Invalid URI: The format of the URI could not be determined." error
			const redirectUri = window.location.origin + window.location.pathname;

			getOAuthToken({
				code: code,
				redirectUri,
			})
				.then(() => {
					updateShowComponent(true);

					// Supprimer le paramètre "code" de l'URL sans déclencher de navigation
					const url = new URL(window.location);
					url.searchParams.delete("code");
					window.history.replaceState(null, "", url.toString());
				})
				.catch(() => {
					navigate(
						{
							pathname: "/technical-error/sso",
							search: `?redirectUri=${redirectUri}`,
						},
						{ replace: true }
					);
					sendTagOnOauthAccessTokenFailed();
				});
		}
	}, [code, strategy]);

	// showComponent can be undefined making the app to crash, generating this error https://react.dev/errors/152?invariant=152&args%5B%5D=Component
	return showComponent
		? Children.map(children, child => {
				return cloneElement(child);
			})
		: null;
};

export default OauthRoute;
